import { createContext, useContext, useState } from "react";

const FGCustomBottlerSelectionContext = createContext();

// Context Provider Component
export const FGCustomBottlerSelectionProvider = ({ children }) => {
  const [customSelectedData, setCustomSelectedData] = useState([]);

  return (
    <FGCustomBottlerSelectionContext.Provider
      value={{ customSelectedData, setCustomSelectedData }}
    >
      {children}
    </FGCustomBottlerSelectionContext.Provider>
  );
};

// Custom Hook for easy access
export const useFGCustomBottlerSelection = () =>
  useContext(FGCustomBottlerSelectionContext);
